/**
 * Created by Andromeda on 11/19/16.
 */
'use strict';
//messages
import './assets/css/messages.css';
//require('summernote/dist/summernote.css');
import 'angular-summernote';

import 'ng-file-upload-shim';
import 'ng-file-upload';
//import 'angular';
// import 'angucomplete-alt';
//import 'aws-sdk';
//import 'connect-multiparty';
// import 'angularPrint';

// import './assets/lib/angucomplete-alt/angucomplete-alt.css';
import './assets/lib/angularPrint/angularPrint.css';

// import './assets/lib/angucomplete-alt/angucomplete-alt.js';
import './assets/lib/angularPrint/angularPrint.js';



// WEBPACK FOOTER //
// ./packages/custom/messages/public/index.js